{
  "name": "@unifold/core",
  "version": "1.6.0",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.core/application": "*",
    "@homer.core/client.info": "*",
    "@homer.core/emitter": "*",
    "@homer.core/session": "*",
    "@homer.core/storage.local": "*",
    "@homer.core/when.loaded": "*",
    "@homer.utility/object.filter.undefined": "*",
    "@homer.utility/object.sort": "*",
    "@homer.utility/uuid": "*",
    "@homer.utility/validator.isarray": "*",
    "@homer.utility/validator.isfunction": "*",
    "@homer.utility/validator.isinteger": "*",
    "@homer.utility/validator.isnumeric": "*",
    "@homer.utility/validator.isobject": "*",
    "@homer.utility/validator.isstring": "*",
    "@homer.utility/validator.isundefined": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
